export default {
    path: '/',
    name: 'root',
    redirect: '/entrar',
}